export function localDateToUtcDate(localDate: Date): Date {
  const year = localDate.getUTCFullYear().toString();
  const month = (localDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = localDate.getUTCDate().toString().padStart(2, '0');
  return new Date(`${month}/${day}/${year}`);
}
